<template>
  <Modal :open="isMaintenanceNoticeOpen" size="sm" :title="maintenanceMessage.title" @close="closeMaintenanceNotice">
    <p class="text-sm text-white/70 leading-relaxed">
      {{ maintenanceMessage.text }}
    </p>
    <template #footer>
      <div class="flex justify-end">
        <Button type="button" size="sm" @click="closeMaintenanceNotice">Entendi</Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import Modal from '../ui/Modal.vue'
import Button from '../ui/Button.vue'
import { maintenanceMessage } from '../../utils/maintenance.js'
import { useSignupModal } from '../../composables/useSignupModal.js'

const { isMaintenanceNoticeOpen, closeMaintenanceNotice } = useSignupModal()
</script>
